<template>
	<div class="second-wraper">
		<div class="second-content second-content1" v-if="activeIndex==0">
			<el-tabs class="diyTabs" value="first">
				<el-tab-pane label="专家团队" name="first">
					<!-- <p class="tab-title"><strong>团队介绍</strong></p>
					<p>公司创始人，董事长钟生平博士，为北京市特聘专家，中关村高端领军人才，四川大学生物医学工程系客座教授，生物材料专家。钟生平博士于1993年获得英国利物浦大学皇家医学院博士学位后，曾在波科等国际知名医疗器械公司任职，先后获得近50项美国专利，并发表多篇学术研究论文。2006年钟生平博士回国创立了易生科技（北京）有限公司，成功研发具有完全可降解涂层的第三代药物支架—爱立® Tivoli®冠脉药物洗脱支架，在2012年实现销售收入过亿元。</p>
					<p>
金仕生物创立于2012年，至今已汇聚了几十位来自国内外知名院校的博士、硕士等研发人员，大都具备在国际一流企业工作背景，公司创新基因强，目前已拥有众多国内外发明专利。
					</p> -->
					
				</el-tab-pane>
			</el-tabs>
			<img :src="dataList[0].imgSrc" class="imgItem" />
		</div>
		<div class="second-content second-content2" v-if="activeIndex==1">
			<el-tabs class="diyTabs" v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="大客户经理" name="first">
					<p>工作地点：广州、武汉、云南</p>
					<p>所属部门：市场销售部</p>
					<p><strong>岗位职责：</strong></p>
					<ol>
						<li>1. 负责当地市场的开发和上量工作；</li>
						<li>2. 根据公司整体市场发展策略，专业推广现有产品线；</li>
						<li>3. 高效完成相关全国及地区性各项学术活动；</li>
						<li>4. 确保公司所制定的各项责任区域销售指标的100%达成；</li>
						<li>5. 维护和发展现有正在合作的客户，配合公司整体资源与相关代理商共同发展更多的目标客户；</li>
						<li>6. 科学管理责任区域内现有经销商，针对尚未开发目标市场有计划性的发展有价值的新经销商。</li>
					</ol>
					<p><strong>任职要求：</strong></p>
					<li>1. 本科学历，男女不限；</li>
					<li>2. 至少5年医疗器械领域或外企医药领域工作经验；</li>
					<li>3. 医学相关专业优先考虑，心血管领域工作经验优先考虑；</li>
					<li>4. 销售能力突出、执行力强；</li>
					<li>5. 沟通能力和团队协作能力好。</li><br/>
					简历请发邮箱：luojing@kingstronbio.com<br/>
					联系人：罗经理<br/>
					电话：010-84148525转2018<br/>
					信件接收地址：<br/>
					北京市朝阳区望京科技创业园F座3层302室&nbsp;&nbsp;邮编：100102
				</el-tab-pane>
				<el-tab-pane label="高级研发工程师" name="second">
					<p>工作地点：北京望京</p>
					<p>所属部门：研发部</p>
					<p><strong>岗位职责：</strong></p>
					<ol>
						<li>1. 负责科技项目申请；</li>
						<li>2. 协助产品研发工作；</li>
						<li>3. 与相关部门进行工作协调，进行新产品研发、技术创新、工艺技术改进工作，有项目管理经验者优先；</li>
						<li>4. 熟悉医疗器械产品的各项法规要求、ISO13485。</li>
					</ol>
					<p><strong>任职要求：</strong></p>
					<ol>
						<li>1. 具有理工科（化学、材料、机械学）或医学相关的博士或硕士学位，有高影响因子英文论文3篇以上优先；</li>
						<li>2. 具有国级或者省部级科技项目申请经历，有优秀的项目申请书撰写经验者优先；</li>
						<li>3. 具有严谨的科研态度，较强的论文撰写能力；</li>
						<li>4. 有良好的人际交流及沟通能力，优秀的团队合作能力和实验动手能力；</li>
						<li>5. 化学、材料、机械等专业优先，工作经验不限。</li>
					</ol><br/>
					简历请发邮箱：luojing@kingstronbio.com<br/>
					联系人：罗经理<br/>
					电话：010-84148525转2018<br/>
					信件接收地址：<br/>
					北京市朝阳区望京科技创业园F座3层302室&nbsp;&nbsp;邮编：100102
				</el-tab-pane>
				<el-tab-pane label="研发工程师" name="third">
					<p>工作地点：北京望京</p>
					<p>所属部门：研发部</p>
					<p><strong>岗位职责：</strong></p>
					<ol>
						<li>1. 负责产品相关设计、产品生产工艺开发及生产设备选型；</li>
						<li>2. 参与或组织产品研发相关活动（策划、立项、输入、产品设计、产品验证/确认、输出、设计更改、风险管理）各类评审活动及相关会议；</li>
						<li>3. 负责分管产品和零部件结构设计开发和图纸化；</li>
						<li>4. 负责产品及生产工艺的验证或确认、负责建立产品检测方法及设备选型；</li>
						<li>5. 负责或协助新产品的工艺导入、工艺确认、生产设备和工装的开发；与生产部门、制造商协调确保产品满足生产工艺要求；</li>
						<li>6. 负责设计变更同步的设计图纸、文件的修改和验证；</li>
						<li>7. 负责与质量部门沟通协调，确保设计及输出文件满足公司质量体系和相关法规要求；</li>
						<li>8. 协助进行新产品涉及的生产工艺和使用的培训；</li>
						<li>9. 负责产品设计开发涉及的专利的撰写申报。</li>
					</ol>
					<p><strong>任职要求：</strong></p>
					<ol>
						<li>1. 本科及以上学历，机械、材料、高分子相关专业；</li>
						<li>2. 具有5年以上工作经验，具有医疗器械，尤其是植入医疗器械研发经验者优先考虑；</li>
						<li>3. 有塑料模具件相关医疗产品设计和开发经验者优先考虑；</li>
						<li>4. 熟练使用常用制图软件；</li>
						<li>5. 熟悉医疗器械的法律法规、ISO 13485质量体系或YY/T0287，熟悉YY/T 0316风险管理；</li>
						<li>6. 熟练使用办公软件；</li>
						<li>7. 工作勤奋踏实，思维清晰；创新意识强，具有良好的沟通能力与协作精神。</li>
					</ol><br/>
					简历请发邮箱：luojing@kingstronbio.com<br/>
					联系人：罗经理<br/>
					电话：010-84148525转2018<br/>
					信件接收地址：<br/>
					北京市朝阳区望京科技创业园F座3层302室&nbsp;&nbsp;邮编：100102
				</el-tab-pane>
			</el-tabs>
			<!-- <p class="tab-email">
				<el-tooltip placement="top-start">
				  <div slot="content" class="tips-con">
					  简历请发邮箱：luojing@kingstronbio.com<br/>
					  联系人：罗经理<br/>
					  电话：010-84148525转2018<br/>
					  信件接收地址：<br/>
					  北京市朝阳区望京科技创业园F座3层302室&nbsp;&nbsp;邮编：100102</div>
				  <span class="icon"></span>
				</el-tooltip>
			</p> -->
		</div>
		<div class="second-content second-content3" v-if="activeIndex==2">
			<div class="content-box">
				<div class="row-item">
					<div class="col-item">
						<p class="tab-title"><strong>北京研发中心</strong></p>
						<p>地址：北京朝阳区望京科技创业园F座302室 401室</p>
						<p>邮编：100102</p>
						<p>电话：010-84148525  </p>
						<p>传真：010-84148530</p>
					</div>
					<div class="col-item">
						<p class="tab-title"><strong>苏州市常熟总部工厂</strong></p>
						<p>地址：江苏省苏州市常熟经济技术开发区高新技术产业园盘锦北路9号</p>
						<p>邮编：215505</p>
						<p>电话：0512-52212600</p>
						<p>传真：0512-52212600</p>
					</div>
				</div>
				<div class="row-item">
					<div class="col-item">
						<div class="mapBox" id="map-container"></div>
					</div>
					<div class="col-item">
						<div class="mapBox" id="map-container2"></div>
					</div>
				</div>
			</div>
			
		</div>
		<!-- <pagination :list="tab1List" v-if="activeIndex==0" ></pagination>
		
		 
		    <pagination :list="tab2List" v-if="activeIndex==1 && tab2List.length>2" ></pagination> -->
		<MaskCom :list="childList" v-if="modalVisible"></MaskCom>
	</div>

</template>

<script>
	import Pagination from '../components/Pagination.vue';
	import MaskCom from '../components/MaskCarousel.vue';
	import LeftMenu from '../components/LeftMenu.vue';
	// 引入加载TXMap的方法
	// import TMap from "@/libs/initMap";
	//生命周期 - 挂载完成（可以访问DOM元素）
	
	export default {
		name: 'KingstronSecond',
		components: {
			Pagination,
			MaskCom,
			LeftMenu
		},
		data() {
			return {
				mainForm: {
					address: '',
					lat: '',
					lng: '',
				},
				activeName: 'first',
				modalVisible: false,
				activeIndex: 1,
				childList: [], // 弹出框中需要的数据
				dataList: [{
					imgSrc: require("../../static/contact/swiper-item1-d1.png"),
				}],
				tab2List: [{
					// imgSrc: require("../../static/p4-img2-d.png"),
					// row1List:[{
					// 	imgSrc:require("../../static/p4-img2-d1-1.png")
					// },{
					// 	imgSrc:require("../../static/p4-img2-d1-2.png")
					// },{
					// 	imgSrc:require("../../static/p4-img2-d1-3.png")
					// },{
					// 	imgSrc:require("../../static/p4-img2-d1-4.png")
					// }],
					// row2List:[{
					// 	imgSrc:require("../../static/p4-img2-d1-5.png")
					// },{
					// 	imgSrc:require("../../static/p4-img2-d1-6.png")
					// },{
					// 	imgSrc:require("../../static/p4-img2-d1-7.png")
					// }],
					// row3List:[{
					// 	imgSrc:require("../../static/p4-img2-d1-8.png")
					// },{
					// 	imgSrc:require("../../static/p4-img2-d1-9.png")
					// }]
				}],

			}
		},
		methods: {
			handleClick(tab, event) {
				// console.log(tab, event);
			},
			showModal(subIndex, listIndex) {
				this.modalVisible = true;
				var obj;
				if (listIndex && listIndex == 'row1') {
					obj = this.tab2List[0].row1List[subIndex];
				} else if (listIndex && listIndex == 'row2') {
					obj = this.tab2List[0].row2List[subIndex];
				} else if (listIndex && listIndex == 'row3') {
					obj = this.tab2List[0].row3List[subIndex];
				} else {
					obj = this.tab1List[0].subList[subIndex];
				}
				this.childList[0] = obj;
			},
			hideModal() {
				this.modalVisible = false;
				// this.activeBtn = null;
			},
			backPrevMenu() { //返回上级目录
				this.$parent.closePage();
			},
			setActiveItem(index) {
				this.$refs.carousel.setActiveItem(index);
			},
			// 打开地图弹窗
			openMap() {
				this.$refs.ms.show();
				// 根据省市区设置初始值
				// this.$refs.ms.setLocationByAddress(this.mainForm.address);
				// 根据经纬度设置初始值
				this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
			},
			
			// 地址选择后的回调函数
			selectAddress(address, lat, lng) {
				this.mainForm.address = address;
				this.mainForm.lat = lat;
				this.mainForm.lng = lng;
			},
			BaiduMap() {
				const map = new BMap.Map('map-container');
				var poi = new BMap.Point(116.480646, 40.017973);
				map.centerAndZoom(poi, 17);
				map.enableScrollWheelZoom();
			
				var content = '<div>' + '地址：北京朝阳区望京科技创业园F座302室 401室' + '</div>';
				var marker = new BMap.Marker(poi); //创建marker对象
			
				var searchInfoWindow = null;
				searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
					title: '金仕生物北京研发中心', //标题
					width: 150, //宽度
					height: 40, //高度
					offset: {
						width: 0,
						height: -10,
					},
					enableAutoPan: true, //自动平移
					searchTypes: [
						BMAPLIB_TAB_TO_HERE //到这里去
					]
				});
				marker.addEventListener('click', function(e) {
					searchInfoWindow.open(marker);
				});
				map.enableScrollWheelZoom();
				map.addOverlay(marker);
				
				
				const map2 = new BMap.Map('map-container2');
				var poi2 = new BMap.Point(120.724706, 31.718382);
				map2.centerAndZoom(poi2, 17);
				map2.enableScrollWheelZoom();
			
				var content2 = '<div>' + '地址：江苏省苏州市常熟经济技术开发区高新技术产业园盘锦北路9号' + '</div>';
				var marker2 = new BMap.Marker(poi2); //创建marker对象
			
				var searchInfoWindow2 = null;
				searchInfoWindow2 = new BMapLib.SearchInfoWindow(map2, content2, {
					title: '金仕生物苏州市常熟总部工厂', //标题
					width: 150, //宽度
					height: 40, //高度
					offset: {
						width: 0,
						height: -10,
					},
					enableAutoPan: true, //自动平移
					searchTypes: [
						BMAPLIB_TAB_TO_HERE //到这里去
					]
				});
				marker2.addEventListener('click', function(e) {
					searchInfoWindow2.open(marker2);
				});
				map2.enableScrollWheelZoom();
				map2.addOverlay(marker2);
			},
			loadSearchInfo() {
				// 添加SearchInfoWindow脚本
				const searchInfoWindowScript = document.createElement('script');
				searchInfoWindowScript.type = 'text/javascript';
				searchInfoWindowScript.src = '//api.map.baidu.com/library/SearchInfoWindow/1.5/src/SearchInfoWindow_min.js';
				document.head.appendChild(searchInfoWindowScript);
			
				// 添加SearchInfoWindow样式
				const searchInfoWindowStyle = document.createElement('link');
				searchInfoWindowStyle.rel = 'stylesheet';
				searchInfoWindowStyle.href = '//api.map.baidu.com/library/SearchInfoWindow/1.5/src/SearchInfoWindow_min.css';
				document.head.appendChild(searchInfoWindowStyle);
			
				// 使用Promise.all等待3个文件都加载完成
				Promise.all([
					new Promise((resolve, reject) => {
						searchInfoWindowScript.onload = resolve;
						searchInfoWindowScript.onerror = reject;
					}),
					new Promise((resolve, reject) => {
						searchInfoWindowStyle.onload = resolve;
						searchInfoWindowStyle.onerror = reject;
					})
				])
					.then(() => {
						// 所有文件都加载完成后触发回调函数
						console.log('所有文件加载完成！');
						this.BaiduMap();
					})
					.catch(error => {
						console.error('文件加载失败：', error);
					});
			}
		},
		computed: {
			// animation: function() {
			//   return `flicker 1s infinite`;
			// }
		},
		mounted() {
			var that = this;
			that.activeIndex = that.$route.params.mid ? that.$route.params.mid : '0';
		},
		created() {
			// 引入百度地图API，传入AK密钥
			const AK = 'jEuAGFs5wlT4AAEOaQgP2G9aArhG0xeG';
		
			// 添加百度地图API脚本
			const baiduMapApiScript = document.createElement('script');
			baiduMapApiScript.type = 'text/javascript';
			baiduMapApiScript.src = `//api.map.baidu.com/api?v=2.0&ak=${AK}&callback=initMap`;
			document.head.appendChild(baiduMapApiScript);
		
			window.initMap = () => {
				// API加载完成后自动调用该函数
				this.loadSearchInfo();
			};
		}
	}
</script>

<style lang="less" scoped>
	@import '../assets/css/index';

	img {
		display: block;
		width: 100%;
	}

	.second-wraper {
		// position: relative;
		.scale(1681, 967);
		.pos-a(0, 0, 4);
		background: #e5e3e1;
		color: #4d4d4d;
	}
	.imgItem2{
		.pos-a(0, 0, 2);
	}
	.second-content {
		width: 100%;
		position: relative;

		.imgItem {
			.scale(1681, 968);
			.pos-a(0, 0, 4);
		}

		.tab-title {
			font-size: 30/@r;
		}

		.tab-name {
			font-size: 18/@r;
			font-weight: bold;
		}

		
	}
	.second-content1{
		p {
			margin-bottom: 40/@r;
			font-size: 18/@r;
			line-height: 32/@r;
		}
		/deep/.is-active{
			color: #4d4d4d !important;
			font-weight: bold;
		}
	}
	.second-content2{
		.scale(1681, 967);
		background: url(../../static/contact/swiper-item2-d.png);
		background-size: cover;
		.tab-email{
			.pos-a(826, 168, 4);
			.icon{
				display: inline-block;
				.scale(119, 34);
				background: url(../../static/icon5.png);
				background-size: cover;
			}
		}
		/deep/.is-active{
			color: #3f8eba !important;
			font-weight: bold;
		}
		/deep/.el-tabs__content{
			height: 810/@r;
			overflow-y: auto;
		}
		/deep/.el-tabs__content::-webkit-scrollbar {
		    width: 10/@r;
		    height: 20/@r;
		}
		
		/* 滚动条上的滚动滑块 */
		/deep/.el-tabs__content::-webkit-scrollbar-thumb {
		    background-color: #888684;
		    border-radius: 32px;
		}
		
		/* 滚动条轨道 */
		/deep/.el-tabs__content::-webkit-scrollbar-track {
		    background-color: #fff;
		    border-radius: 32px;
		}
	}
	.second-content3{
		// font-size: 15/@r !important;
		font-weight: 300;
		z-index: 5;
		.tab-title{
			margin: 0 0 15/@r;
		}
		.content-box {
			.scale(1500, 694);
			.pos-a-center(149,4);
			display: flex;
			justify-content: space-between;
			flex-direction: column;
		}
		.row-item{
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			font-size: 15px;
			.col-item {
				width: 45%;
				.mapBox {
					width: 100%;
					height: 420/@r;
					/deep/.BMapLib_SearchInfoWindow {
						// transform: scale(1);
						// left:37px !important;
						// transform-origin: center bottom;
						.BMapLib_trans {
							width: 58px;
						}
					}
					/deep/.BMap_Marker {
						div {
							.animation(fadeInNew, 0.6s);
							width:24px !important;
						}
					}
				}
			}
		}
	}
	

	/* 自定义 tabs 样式*/
	.diyTabs {
		font-size: 15/@r  !important;
		// .scale(672, 967);
		width: 672/@r;
		.pos-a(80, 168, 4);
	}
	/deep/.el-tabs__header{
		margin: 0;
	}
	/deep/.el-tabs__active-bar,.el-tabs__nav-wrap::after {
		width: 0 !important;
		height: 0 !important;
		background-color: transparent;
	}
	/deep/.el-tabs__nav-wrap::after {
		background-color: transparent;
	}

	/deep/.el-tabs__item:hover,.is-active {
		color: #4d4d4d !important;
	}
	
	.second-content2{
		/deep/.el-tabs__item{
			color: #4d4d4d;
			font-size: 22/@r;
			font-weight: bold;
		}
		
		/deep/.el-tabs__item:hover,.is-active {
			color: #3f8eba !important;
		}
	}
	/deep/.el-tabs__item{
		color: #4d4d4d;
	}
	
	/deep/.el-tabs__content {
		.el-tab-pane {
			// color: #000000 !important;
			font-weight: 400;
			font-size: 18/@r;
			line-height: 32/@r;
		}
	}
	.tips-con{
		line-height: 40/@r !important;
	}
	ol{
		padding-left: 0;
	}

	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100
	}
	
	@keyframes fadeInNew{
		0%{
			opacity: 0.2;
		}
		100%{
			opacity: 1;
		}
	}
</style>
